import { Grid } from '@material-ui/core';
import React, { FC, HTMLAttributes } from 'react';
import { Spinner } from '../index';
import { Config } from 'src/state/Config';
import { LoadingMessage } from './LoadingScreen.styles';

interface Props {
  text?: string;
  spinnerSize?: number;
}

export const LoadingScreen: FC<Props & HTMLAttributes<HTMLElement>> = ({
  spinnerSize = 50,
  text = 'Loading',
  children,
  ...props
}) => {
  const color = Config.isRealkreditDenmark() ? 'secondary' : 'primary';

  return (
    <Grid
      container
      alignContent="center"
      alignItems="center"
      direction="column"
      {...props}
    >
      <Grid item xs>
        <Spinner color={color} size={spinnerSize} />
      </Grid>
      <Grid item xs>
        <LoadingMessage>{text}</LoadingMessage>
      </Grid>
    </Grid>
  );
};
